import { useQuery } from "@tanstack/react-query";
import { useParams, useSearchParams } from "react-router";
import { useWorkspaceContext } from "@core/context";
import { getAnnotationsNotes } from "@modules/docs/annotations/services/annotationService";

export function useGetAnnotationNotes(annotationId: string) {
  const { workspaceId } = useWorkspaceContext();
  const { projectId } = useParams<{ projectId: string }>();
  const [searchParams] = useSearchParams();
  const approvalId = searchParams.get("approval_id") ?? "";

  return useQuery({
    queryKey: ["annotation-notes", workspaceId, projectId, approvalId, annotationId],
    queryFn: () =>
      getAnnotationsNotes(workspaceId, projectId!, approvalId, annotationId),
    enabled: !!workspaceId && !!projectId && !!approvalId && !!annotationId,
  });
}
